import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import learnService from "./learnService";

const initialState = {
    learns: [],
    learnsIsError: false,
    learnsIsSuccess: false,
    learnsIsPending: false,
    learnsMessage: ""
}

export const getAllLearns = createAsyncThunk('get the learns', async (_, thunkAPI) => {

        try {
            // const token = thunkAPI.getState().auth.user.token
            const state = thunkAPI.getState()
            const token = state.auth.token
            // return await learnService.getAllLearns(token)
            return await learnService.getAllLearns(token)
        } catch (error) {
            const learnsMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(learnsMessage)
        }
    }
)


export const learnSlice = createSlice({
    name: "learn", //?
    initialState,
    reducers:{
        reset: (state) => initialState
    },
    extraReducers: (builder) =>{
        builder
            .addCase(getAllLearns.pending, (state) =>{
                state.learnsIsPending = true;

            })
            .addCase(getAllLearns.fulfilled, (state, action) =>{
                state.learnsIsPending = false;
                state.learnsIsSuccess = true;
                state.learns = action.payload;
                // console.log(action.payload)

            })
            .addCase(getAllLearns.rejected, (state, action) =>{
                state.learnsIsPending = false;
                state.learnsIsSuccess = false;
                state.learnsIsError = true;
                state.message = action.payload
            })
    }
})

export const { reset } = learnSlice.actions;
export default learnSlice.reducer;
